module.exports = __webpack_public_path__ + "static/media/ccc_logo.a72380b7.svg";